import {
  adjustVolume,
  currentEpisode,
  nowPlayingOpen,
  skipBack,
  skipForward,
  stepPlaybackRate,
  toggleMute,
  togglePlay,
} from '../state/player';

/**
 * Global playback shortcuts (#63) — Space/K to play or pause, ArrowLeft/Right or J/L to skip,
 * ArrowUp/Down to adjust volume, M to toggle mute, `,`/`.` to nudge playback speed,
 * and P to toggle the now playing sheet.
 */

/**
 * True while the key would otherwise be typed into a field, or is meant for whatever's focused
 * inside an open dialog — a shortcut firing underneath that is a bug, not a feature.
 */
export function shouldIgnoreShortcut(target: EventTarget | null): boolean {
  if (!(target instanceof HTMLElement)) return false;
  if (target.isContentEditable) return true;
  return target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.tagName === 'SELECT';
}

export function handlePlaybackShortcut(e: KeyboardEvent): void {
  if (e.metaKey || e.ctrlKey || e.altKey) return;
  if (!currentEpisode.value) return;
  if (shouldIgnoreShortcut(e.target)) return;

  switch (e.key) {
    case ' ':
    case 'k':
      e.preventDefault();
      togglePlay();
      break;
    case 'ArrowLeft':
    case 'j':
      e.preventDefault();
      skipBack();
      break;
    case 'ArrowRight':
    case 'l':
      e.preventDefault();
      skipForward();
      break;
    case 'ArrowUp':
      e.preventDefault();
      adjustVolume(0.05);
      break;
    case 'ArrowDown':
      e.preventDefault();
      adjustVolume(-0.05);
      break;
    case 'm':
    case 'M':
      e.preventDefault();
      toggleMute();
      break;
    case 'p':
    case 'P':
      e.preventDefault();
      nowPlayingOpen.value = !nowPlayingOpen.value;
      break;
    case ',':
    case '<':
      e.preventDefault();
      stepPlaybackRate(-1);
      break;
    case '.':
    case '>':
      e.preventDefault();
      stepPlaybackRate(1);
      break;
  }
}
